import {type MouseEventHandler} from 'react';
import {FormattedMessage} from 'react-intl';
import {Dialog, type DialogProps, DialogContent, Grid, Typography} from '@mui/material';
import {makeStyles} from '@mui/styles';
import {DeleteButton, CancelButton} from 'components/buttons';
import {Alert} from 'components/feedbacks';

const useStyles = makeStyles(() => ({
  dialog: {
    paddingTop: 32
  },
  content: {
    paddingTop: 32
  },
  name: {
    fontSize: 22
  },
  alert: {
    marginTop: 16
  }
}), {name: 'DeleteBookmarkDialog'});

type DeleteBookmarkDialogProps = DialogProps & {
  errorReason?: string;
  bookmarkName: string;
  submitting: boolean;
  handleDeleteBookmark: MouseEventHandler<HTMLButtonElement>;
  onClose: MouseEventHandler<HTMLButtonElement>;
}

const DeleteBookmarkDialog = ({errorReason, bookmarkName, open, onClose, submitting, handleDeleteBookmark} : DeleteBookmarkDialogProps) : JSX.Element => {
  const classes = useStyles();
  return <Dialog open={open} onClose={onClose} maxWidth='xs'>
    <DialogContent className={classes.content} dividers>
      <Grid container spacing={4} justifyContent='center'>
        <Grid item>
          <Grid container spacing={1} justifyContent='center' alignItems='center'>
            <Grid item xxs={12} container justifyContent='center'>
              <Typography variant='h6' color='primary'><FormattedMessage id='admin.bookmarks.delete.title' /></Typography>
            </Grid>
            <Grid item xxs={12} container justifyContent='center' alignItems='center'>
              <Typography className={classes.name} variant='h6' color='primary'>&quot;{bookmarkName}&quot;</Typography>
              <Typography variant='h6' color='primary'>&nbsp;?</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container spacing={4} justifyContent='space-around'>
            <Grid item>
              <CancelButton className='bg-admin-blue-300' loading={submitting} onClick={onClose} />
            </Grid>
            <Grid item>
              <DeleteButton className='bg-admin-red-300' loading={submitting} onClick={handleDeleteBookmark} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {errorReason && <Alert>
        <Typography><FormattedMessage id={'admin.bookmarks.action.failed.' + errorReason} /></Typography>
      </Alert>}
    </DialogContent>
  </Dialog>
}

export default DeleteBookmarkDialog;